// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React, { useCallback } from "react";

import { Update as StyledUpdate } from "./styles";
import { ButtonOutline } from "src/styles/buttons";
import Icon from "src/icons";

import type { AppState, Updates as UpdatesType } from "src/types";

type Props = {
  updates: UpdatesType,
};

const Update = ({ updates }: Props) => {
  const handleUpdate = useCallback(
    (e: any) => {
      e.preventDefault();
      // Hard refresh page
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
    },
    [updates],
  );

  if (
    process.env.RELEASE_VERSION !== updates.newVersion &&
    updates.newVersion
  ) {
    return (
      <StyledUpdate>
        {i18n.t(k.A_NEW_VERSION_OF_UNIFIZE_HAS_B)}
        <ButtonOutline
          data-cy="handle-update-btn"
          type="button"
          onClick={handleUpdate}
        >
          <Icon type="update" />
          <span>{i18n.t(k.UPDATE_NOW)}</span>
        </ButtonOutline>
      </StyledUpdate>
    );
  }
  return <></>;
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  updates: app.updates,
});

export default connect(mapStateToProps)(Update);
